export default function GrowGardenIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="40" width="56" height="20" rx="6" fill="#8a5428" />
      <path
        d="M10 48h44M10 54h44"
        stroke="#5a3414"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M32 42V22"
        stroke="#3f8a2a"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path d="M32 30c-10 0-14-6-14-12 8 0 14 4 14 12z" fill="#5bd16b" />
      <path d="M32 26c8 0 13-5 13-11-7 0-13 4-13 11z" fill="#3fae3a" />
      <circle cx="44" cy="12" r="7" fill="#ff5a5a" />
      <circle
        cx="17"
        cy="34"
        r="6"
        fill="#ffd84d"
        stroke="#e0a800"
        strokeWidth="1.5"
      />
      <path d="M50 30l2 4 4 1-3 3 1 4-4-2-4 2 1-4-3-3 4-1z" fill="#ffd84d" />
    </svg>
  );
}
